module.exports = __webpack_public_path__ + "img/nft.1d72f701.png";